const titleMinHeight = 54;
const titleRoundBorderWidth = 3;
const titleRoundRightMargin = 24;

const titlePadMinHeight = 46;
const titlePadRoundBorderWidth = 2;
const titlePadRoundRightMargin = 18;

const titleMobileMinHeight = 32;
const titleMobileRoundBorderWidth = 1.5;
const titleMobileRoundRightMargin = 16;

const styles = theme => ({
  root: {
    backgroundColor: "white",
    "& h1": {
      fontSize: "45px",
      lineHeight: "45px",
      fontWeight: theme.typography.fontWeightMedium,
      textTransform: "uppercase",
      color: theme.palette.greenMain,
      textShadow: "0px 2px 6px rgba(0, 0, 0, 0.18)",
      marginTop: "0px",
      marginBottom: "12px",
      ['@media (max-width: 768px)']: {
        fontSize: "20px",
        lineHeight: "26px",
        marginBottom: "3px",
        textShadow: "none",
      },
    },
    padding: "32px 0px",
    position: "relative",
    "& .MuiDialog-paper": {
      width: "100%",
      maxWidth: "85vw",
      padding: "70px 120px",
      borderRadius: "4px",
      ['@media (max-width: 992px)']: {
        padding: "70px 50px",
      },
      ['@media (max-width: 768px)']: {
        padding: "70px 25px",
        maxWidth: "100vw",
        margin: "0px",
        borderRadius: "0px"
      },
    },
    "& .MuiDialog-paperScrollPaper": {
      ['@media (max-width: 768px)']: {
        maxHeight: "100%",
      },
    },
    ['@media (max-width: 768px)']: {
      padding: "0px",
    },
  },
  container: {
    padding: "50px 16px 100px",
    fontSize: "20px",
    color: theme.palette.black,
    ['@media (max-width: 768px)']: {
      padding: "24px 24px",
    },
  },
  loader: {
    display: "block",
    margin: "0px auto"
  },
  sectionTitleContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    flexGrow: "1",
    minHeight: `${titleMinHeight}px`,
  },
  sectionName: {
    flexGrow: "1"
  },
  overview: {
    width: "100%"
  },
  buttonContainer: {
    marginTop: "35px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 12px",
    ['@media (max-width: 768px)']: {
      margin: "32px -12px 0px"
    },
  },
  button: {
    minWidth: "410px",
    ['@media (max-width: 768px)']: {
      minWidth: "1px",
      width: "100%",
      maxWidth: "350px"
    },
  },
});

export default styles;